// extracted by css-extract-rspack-plugin
export default {"ActionMenu_Overlay":"sort-by-menu-module__ActionMenu_Overlay__Cs9ga","Box":"sort-by-menu-module__Box__e3TUV","Box_1":"sort-by-menu-module__Box_1__xdDKB"};